<script setup>
/*
    Tabs widget

    Components:
        primary: <v-toolbar>

    Widget Properties:
        items: Name:URL, Name:URL, Name:URL, ...
        [{name, to}, {name, to}, ...]

    Component Args

    CSS Properties:

    Usage:

    ['Paris:/products', 'Seattle:/account', 'Melbourne:/clouds']
 */
import {reactive, ref} from 'vue'
import {getWidgetProps} from '@/paks/vu-dash/BoardUtils'
import {go} from '@/paks/vu-app'
import Json5 from 'json5'

defineExpose({update})

const props = defineProps({
    widget: Object,
})

const page = reactive({
    args: {},
    data: {},
    items: [],
    tab: 0,
})

const primary = ref(null)

function update() {
    let widget = props.widget
    Object.assign(page, getWidgetProps(widget, {primary}))

    page.title = widget.header
    let items = widget.items?.trim()
    try {
        if (items[0] == '{' || items[0] == '[') {  // '}'
            items = Json5.parse(items)
        } else {
            throw true
        }
    } catch (err) {
        items = items.split(',').map((i) => i?.trim())
    }
    items = items.map((i) => {
        let [name, to] = i.split(':')
        return {name: name.trim(), to: to?.trim(), disabled: false}
    })
    page.items = items
}

function jump(item) {
    if (item.to) {
        go(item.to)
    }
}
</script>

<template>
    <v-toolbar class="tabs-widget" color="surface" flat ref="primary">
        <v-toolbar-title v-if="page.title">{{ page.title }}</v-toolbar-title>
        <v-toolbar-items v-if="page.items.length > 1">
            <v-tabs v-model="page.tab" ref="tabs">
                <slot>
                    <v-tab
                        ripple
                        v-for="item of page.items"
                        :key="item.name"
                        :disabled="item.disabled"
                        @click="jump(item)">
                        {{ item.name }}
                    </v-tab>
                </slot>
            </v-tabs>
        </v-toolbar-items>
    </v-toolbar>
</template>

